import styled from 'styled-components';
import { Toggle } from '../../';

export const Name = styled.span`
  display: flex;
  font-family: NLRTM-Bold, sans-serif;
  font-weight: bold;
  line-height: 1.75rem;
  font-size: 0.9rem;
  user-select: none;
  margin-right: ${(props) => props.theme.spacing['32px']};
`;

export const StyledNotificationRule = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: ${(props) => props.theme.spacing['16px']}
    ${(props) => props.theme.spacing['16px']};
  background-color: ${(props) => props.theme.colors.primary.white};
  border-bottom: 1px solid #e6e4e2;
`;

export const SwitchGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Label = styled.span`
  font-size: 0.9rem;
  line-height: 2rem;
  user-select: none;
`;

export const StyledToggle = styled(Toggle)`
  p {
    font-family: NLRTM-Bold, sans-serif;
    min-width: 28px;
  }
`;
